<template>
    <Card :header="$t('passwordSettings')" content-class="d-flex flex-wrap gap-column-3 child-flex-basis-100">

        <FormValidator :validator="$v.form.oldPassword" form-group v-slot="slotProps" :label="$t('oldPassword')">
            <b-form-input v-model="form.oldPassword" :disabled="busy" :state="slotProps.state" type="password" />
        </FormValidator>

        <FormValidator :validator="$v.form.newPassword.first" form-group v-slot="slotProps" :label="$t('newPassword')" class="flex-basis-40 flex-grow-1 flex-shrink-0 width-min-200">
            <b-form-input v-model="form.newPassword.first" :disabled="busy" :state="slotProps.state" type="password" />
        </FormValidator>

        <FormValidator :validator="$v.form.newPassword.second" form-group v-slot="slotProps" :label="$t('repeatNewPassword')" class="flex-basis-40 flex-grow-1 flex-shrink-0 width-min-200">
            <b-form-input v-model="form.newPassword.second" :disabled="busy" :state="slotProps.state" type="password" />
        </FormValidator>

        <div class="d-flex gap-3 mt-5">
            <ButtonIcon :loading="saving" :disabled="busy" class="wide" @click="formSubmit()">
                {{ $t('save') }}
            </ButtonIcon>
        </div>

    </Card>
</template>



<script>
    import FormValidator from '@/components/common/FormValidator.vue';
    import { required } from 'vuelidate/lib/validators';
    import formBackendValidationMixin from '@/mixins/formBackendValidationMixin';
    import { scrollToElement } from '@/utils/util';
    import cloneDeep from 'lodash/cloneDeep';

    const FORM_DEFAULT_DATA = Object.freeze({
        oldPassword: '',
        newPassword: {
            first: '',
            second: '',
        },
    });

    export default {
        name: 'PasswordSettings',
        mixins: [formBackendValidationMixin],
        components: {
            FormValidator,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.parentComponent.requestUserPassword,
                form: cloneDeep(FORM_DEFAULT_DATA),
                formValidations: {
                    form: {
                        oldPassword: { required },
                        newPassword: {
                            first: { required },
                            second: { required },
                        },
                    },
                },
            };
        },
        computed: {
            saving() {
                return this.request.getLoading('post');
            },
            busy() {
                return this.saving;
            },
        },
        methods: {
            initFormData() {
                this.form = cloneDeep(FORM_DEFAULT_DATA);
            },
            async formSubmit() {
                this.$v.form.$touch();
                if (this.$v.form.$invalid) {
                    await this.$nextTick();
                    scrollToElement('.is-invalid', { offset: -80 });
                    return;
                }
                this.request
                    .id('post')
                    .post({ requestParams: this.form })
                    .then(() => {
                        this.initFormData();
                        this.$toastr.success(this.$t('dataSavedSuccessfully'));
                        this.$v.form.$reset();
                    })
                    .catch(this.handleBackendValidations);
            },
        },
    };
</script>
